// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/maintenance-schedule.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/maintenance-schedule/maintenance-schedule.js';

mount([g0]);
